import React from 'react';
import Icon from '../../../common/Icon';
import Translation from '../../../common/Translation';
import { SegmentInspiration } from '../../../search/helpers/SegmentHelper';

const Select = ({
  id,
  name,
  label,
  value,
  defaultValue,
  options,
  onChange,
}) => {
  switch (name) {
    case 'audience':
      const audienceSortOrder = ['17740', '17739', '6882', '11022', '11023', '24749']
      options.sort((a, b) => audienceSortOrder.indexOf(a.value) - audienceSortOrder.indexOf(b.value))
    break;
    case 'interest':
      const interestSortOrder = ['17742', '17781', '17741', '17744', '10844', '17745', '17743', '17955',  '6908', '17780']
      options.sort((a, b) => interestSortOrder.indexOf(a.value) - interestSortOrder.indexOf(b.value))
      break;
    case 'season':
      const seasonSortOrder = ['17749', '17746', '17747', '17748']
      options.sort((a, b) => seasonSortOrder.indexOf(a.value) - seasonSortOrder.indexOf(b.value))
      break;
    default:
      console.log('sort error');
  }

  return (
    <div className={`crtSearch-item crtSearchInspiration${name}`}>
      <label htmlFor={id} className="crtSearchInspirationLabel">
        <Translation id={label}/>
      </label>

      <div className="crtSearchSelect-wpr">
        <select
          id={id}
          name={name}
          className="crtSearchSelect crtSearchInspirationSelector"
          value={value || ''}
          onChange={({ target: { value } }) => onChange(id, value)}
        >
          <option value="">
            { Translation({id: defaultValue})}
          </option>
          {
            options.map(option => (
              <option
                key={option.value}
                value={option.value}
              >
                {SegmentInspiration.getLabel(option.value)}
              </option>
            ))
          }
        </select>
        <Icon name="down" />
      </div>
    </div>
  );
};

export default Select;
